// extracted by mini-css-extract-plugin
export default {"description":"style_description__OKf5j","fade-in":"style_fade-in__P6cFT","top":"style_top__EB4X8","image":"style_image__p3HUx"};